import React from 'react';
import NodeBaseLayout from './components/NodeBaseLayout';

const DefNode = ({ data, isConnectable }) => {
  return (
    <div className="text-updater-node">
      <NodeBaseLayout data={data} isConnectable={isConnectable} />
    </div>
  );
};
export default DefNode;
